import { any, compose, equals, identity, keys, map, memoizeWith, prop, values } from 'ramda';
import { createSelector } from 'reselect';

import { NAME } from './constants';

const getRoot = prop(NAME);

export const getWeeks = compose(prop('weeks'), getRoot);
export const getViewState = compose(prop('viewState'), getRoot);
export const getCurveType = compose(prop('curveType'), getViewState);
export const getIncorrectWeekIds = compose(prop('incorrectWeekIds'), getViewState);

export const getWeeksAsList = createSelector(getWeeks, values);
export const getWeekIds = createSelector(getWeeks, compose(map(Number), keys));
export const getWeekById = createSelector(
	getWeeks,
	(_, weekId) => weekId,
	(weeks, id) => weeks[id],
);

// TODO change selector
export const getIsWeekIncorrect = memoizeWith(identity, (weekId) =>
	createSelector(getIncorrectWeekIds, any(equals(weekId))),
);

export const getIsPristine = (state) =>
	!getViewState(state).curveTypeChanged && !getViewState(state).effectivityChanged;
